export const VALIDATION_LABEL = Object.freeze({
  0: 'Invalidado',
  1: 'Validado',
  2: 'Abstenção',
  3: 'Em análise',
  4: 'Transferido',
})

export function formatDate(dateString) {
  if (!dateString) return ''

  const parts = String(dateString).split('-')
  if (parts.length < 3) return dateString

  const year = parts[0].substring(2)
  const month = parts[1]
  const day = parts[2]

  return `${year}-${month}-${day}`
}

export function getValidationLabel(value) {
  return VALIDATION_LABEL[value] ?? ''
}
